import React from 'react';
import { SearchRange, SearchInputForContentInputType } from '@umu/umu-search/src/searchInputForContent/common/interface';
import { headerTypeData } from '@umu/umu-search/src/searchInputForContent/common/dataflow';
import SearchInputForContentOfUmuNormal from '@umu/umu-search/src/searchInputForContent/umu/normal/searchInputForContentOfUmuNormal';
import SearchInputForContentOfUseNormal from '@umu/umu-search/src/searchInputForContent/use/normal/searchInputForContentOfUseNormal';
import SearchInputForContentOfUmuMicroPage from '@umu/umu-search/src/searchInputForContent/umu/microPage/searchInputForContentOfUmuMicroPage';
import SearchInputForContentOfUseMicroPage from '@umu/umu-search/src/searchInputForContent/use/microPage/searchInputForContentOfUseMicroPage';

type SearchInputForContentProps = {
    inputType: string;
    // Common Input 需要的参数

    // USE Input 需要的参数
    eid?: string;
    sort?: string;
    categoryId?: string;
    keyWords?: string;
    goUseHome?: () => void;
    headerType?: number;

    // UMU Input 需要的参数

    // MicroPage Input 需要的参数
    isLogin?: boolean;
    isInIframe?: boolean;
    microPageId?: string;
    goBack?: () => void;
    searchRange?: SearchRange;
    isEnterpriseAccount?: boolean;
    changeContentMode?: (mode: string) => void;
    handleSearchOfMicroPage?: (keyWords: string) => void;
    changeSearchRange?: (searchRange: SearchRange) => void;
};

function SearchInputForContent(props: SearchInputForContentProps) {
    const {
        eid = '',
        sort = '',
        keyWords = '',
        categoryId = '',
        inputType,
        microPageId = '',
        goBack = () => {},
        goUseHome = () => {},
        changeSearchRange = () => {},
        headerType = headerTypeData.use,
        handleSearchOfMicroPage = () => {},
        searchRange = SearchRange.currentPage,
    } = props;

    const renderSearchInputForContent = (_inputType: string) => {
        switch (_inputType) {
            case SearchInputForContentInputType.umuCommon:
                return <SearchInputForContentOfUmuNormal {...props} />;
            case SearchInputForContentInputType.umuMicroPage:
                return (
                    <SearchInputForContentOfUmuMicroPage
                        {...props}
                        eid={eid}
                        sort={sort}
                        goBack={goBack}
                        keyWords={keyWords}
                        categoryId={categoryId}
                        microPageId={microPageId}
                        searchRange={searchRange}
                        changeSearchRange={changeSearchRange}
                        handleSearchOfMicroPage={handleSearchOfMicroPage}
                    />
                );
            case SearchInputForContentInputType.useCommon:
                return (
                    <SearchInputForContentOfUseNormal
                        {...props}
                        eid={eid}
                        sort={sort}
                        keyWords={keyWords}
                        goUseHome={goUseHome}
                        headerType={headerType}
                        categoryId={categoryId}
                    />
                );
            case SearchInputForContentInputType.useMicroPage:
                return (
                    <SearchInputForContentOfUseMicroPage
                        {...props}
                        eid={eid}
                        sort={sort}
                        goBack={goBack}
                        keyWords={keyWords}
                        goUseHome={goUseHome}
                        headerType={headerType}
                        categoryId={categoryId}
                        microPageId={microPageId}
                        searchRange={searchRange}
                        changeSearchRange={changeSearchRange}
                        handleSearchOfMicroPage={handleSearchOfMicroPage}
                    />
                );
            default:
                return null;
        }
    };

    return <div className="umu-search-input-for-content">{renderSearchInputForContent(inputType)}</div>;
}

export default SearchInputForContent;
